/**
 * created by lei lei on 2020/6/20
 */
import React, {Component} from 'react';
import {Button, Col, Table} from 'antd';
import *as Actions from '../../actions/myMedia'
import {connect} from "react-redux";
import *as Utils from '../../utils'

class MyApplication extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Actions = {...Actions};
        this.state = {
            data: []
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let account = this.props.currentUser.account;
        this.Actions.getAllMedia(account, (data) => {
            let Data = data.data;
            if (Data && Data.length > 0) {
                Data.forEach((item, i) => {
                    item.key = i;
                    item.createTime = Utils.formatMediaDate(item.createTime);
                });
                this.setState({data: Data});
            }
        })
    }

    render() {
        const columns = [
            {
                title: '序号',
                key: 'key',
                align: 'center',
                render: (record) => {
                    return (
                        <div>
                            {parseInt(record.key)+1}
                        </div>
                    )
                }
            },
            {
                title: '申请时间',
                dataIndex: 'createTime',
                key: 'createTime',
                align: 'center'
            },
            {
                title: '媒体类型',
                align: 'center',
                render: (record) => {
                    let mark;
                    if (record.type === "2") {
                        mark = '公众号'
                    } else if (record.type === "3") {
                        mark = '微博'
                    } else if (record.type === "5") {
                        mark = '抖音'
                    }
                    return (
                        <div>
                            {mark}
                        </div>
                    )
                }

            },
            {
                title: '媒体名称',
                dataIndex: 'name',
                key: 'name',
                align: 'center'
            },
            {
                title: '所属部门',
                dataIndex: 'department',
                key: 'department',
                align: 'center'
            },
            {
                title: '负责人',
                dataIndex: 'director',
                key: 'director',
                align: 'center'
            },
            {
                title: '负责人职务',
                dataIndex: 'job',
                key: 'job',
                align: 'center'
            },
            {
                title: '负责人电话',
                dataIndex: 'mobile',
                key: 'mobile',
                align: 'center'
            },


        ];


        return (
            <div className={'MyApplication'}>
                <div style={{
                    height: 56,
                    lineHeight: '56px',
                    background: 'white',
                    width: '100%',
                    float: 'left',
                    borderBottom: '1px solid #ebebeb'
                }}>
                    <div style={{fontSize: 14, paddingLeft: 20, float: 'left', color: '#333333'}}>
                        申请列表
                    </div>
                    <div style={{
                        fontSize: 13,
                        right: 0,
                        color: '#0050B3',
                        float: 'right',
                        marginRight: 20,
                        cursor: 'pointer'
                    }}>
                        <Button onClick={() => {
                            this.exportTable()
                        }} type="primary">导出表格</Button></div>
                </div>
                <div style={{clear: 'both'}}/>
                <Table
                    columns={columns} dataSource={this.state.data} pagination={false} bordered
                    locale={{emptyText: '暂无数据'}}
                />

            </div>
        )
    }

    exportTable() {
        let account = this.props.currentUser.account;
        this.Actions.exportMedia(account, (url) => {
            window.open(url, "_blank");
        })
    }

}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(MyApplication);